<template>
  <div class="main__div">
    <TradeForm @trade-review="reviewTrade" />
    <reviewand-post-trade
      @trade-edit="tradeEdit"
      @share-trade="shareTrade"
      :trade_review_data="trade_review_data"
      v-if="trade_review_data.flag"
    />

    <p class="follow__title" v-if="peopleYouFollowList.length">
      People you follow
    </p>
    <div
      v-if="peopleYouFollowListLoading"
      class="card-container d-flex flex-wrap"
    >
      <v-skeleton-loader
        height="150"
        v-for="item in 6"
        :key="item.id"
        width="370"
        class="mt-5 mx-5"
        type="card-avatar, card,button, actions"
      ></v-skeleton-loader>
    </div>
    <div
      class="cards-container"
      v-if="!peopleYouFollowListLoading && peopleYouFollowList.length"
    >
      <profile-card-component
        class="card-component"
        v-for="item in peopleYouFollowList"
        :key="item.name"
        @reload-home-profile="getUsersList"
        @unfollow="handleUnfollow"
        :profile_object="item"
      />
    </div>

    <p class="influencer__follow__title" v-if="influencers_list.length">
      Recommendations
    </p>
    <div v-if="influencersLoading" class="influencer-cards-container">
      <v-skeleton-loader
        height="170"
        v-for="item in 10"
        :key="item.id"
        width="140"
        class="influencer-card-component mt-10"
        type="card-avatar, card,button, actions"
      ></v-skeleton-loader>
    </div>

    <div v-if="influencersLoading" class="card-container d-flex flex-wrap">
      <v-skeleton-loader
        height="150"
        v-for="item in 6"
        :key="item.id"
        width="370"
        class="mt-5 mx-5"
        type="card-avatar, card,button, actions"
      ></v-skeleton-loader>
    </div>
    <div
      class="cards-container"
      v-if="!influencersLoading && influencers_list.length"
    >
      <profile-card-component
        class="card-component"
        v-for="item in influencers_list"
        :key="item.name"
        @reload-home-profile="getUsersList"
        @follow="handleFollow"
        :profile_object="item"
      />
    </div>

    <div
      class="text-center"
      v-if="
        !influencerHide &&
        influencerNumPages > 1 &&
        influencerPage !== influencerNumPages
      "
      v-intersect="onInfluencerIntersect"
    >
      <v-progress-circular indeterminate color="#2f80ed"></v-progress-circular>
      Loading More...
    </div>
    <!-- </div> -->

    <v-fab-transition class="floatingIcon">
      <v-btn
        color="#2D8CFF"
        dark
        class="mb-3 floatingIcon text-capitalize elevation-4"
        fixed
        bottom
        rounded
        inner-height="44"
        style="z-index: 4"
        right
        @click="addTrade()"
      >
        <v-icon small>mdi-plus</v-icon>
        <span style="font-weight: 800; letter-spacing: 0px">Add Trade</span>
      </v-btn>
    </v-fab-transition>
  </div>
</template>
<script>
import Axios from "@/api/BaseAxios.js";
import ProfileCardComponent from "@/components/Profile/ProfileCardComponent.vue";
import { isAuthenticated } from "../../common/commonFunctions";
import TradeForm from "@/components/Trade/TradeForm.vue";
import ReviewandPostTrade from "@/components/Trade/ReviewandPostTrade.vue";
import { mapActions } from "vuex";

export default {
  metaInfo: {
    title: "Network",
  },

  data() {
    return {
      influencers_list: [],
      peopleYouFollowList: [],
      influencerPage: 1,
      influencerNumPages: 1,
      influencerHide: false,
      influencersLoading: false,
      peopleYouFollowListLoading: false,
      trade_form_data: {
        flag: false,
        id: null,
        trade_data: {},
        trade_edit: false,
      },
      trade_review_data: {
        flag: false,
        trade_data: {},
      },
    };
  },

  methods: {
    ...mapActions({
      toggleTradeModal: "tradeData/toggleModal",
      toggleAddTradeModal: "addTrade/toggleTradeModal",
    }),
    addTrade() {
      // this.$logEvent("add_trade_network_page");
      this.trade_form_data.flag = true;
      // this.toggleTradeModal({show:true,type:'add'})
      this.toggleAddTradeModal({ show: true, type: "add" });
    },
    reviewTrade(data) {
      this.trade_review_data.trade_data = data;
      this.trade_review_data.flag = true;
    },

    tradeEdit(data) {
      this.trade_form_data.trade_data = data;
      this.trade_form_data.trade_edit = true;
      this.trade_form_data.flag = true;
    },
    shareTrade(data) {
      navigator.share(
        {
          title: "Covesto",
          text: `Hello, ${data.posted_by_name} has shared a trade recommendation on Covesto.${data.trade_type} ${data.security_name}
            To know more details and get live updates, follow the trade at `,
          url: `https://covesto.in/trade/${data.id}/${data.security.name}`,
        },
        {
          skype: false,
          pinterest: false,
          print: false,
          sms: false,
        }
      );
      // this.getTradeList(0);
    },

    handleFollow({ user_id, to_follow_id }) {
      const i = this.influencers_list.findIndex(
        (expert) => expert.user_id.toString() === to_follow_id.toString()
      );
      const user = this.influencers_list[i];
      user.followers_ids.push(user_id);
      user.followers = user.followers + 1;
      this.peopleYouFollowList.unshift(user);
      this.influencers_list.splice(i, 1);
    },

    handleUnfollow({ user_id, to_unfollow_id }) {
      const i = this.peopleYouFollowList.findIndex(
        (expert) => expert.user_id.toString() === to_unfollow_id.toString()
      );
      const user = this.peopleYouFollowList[i];
      user.followers_ids = user.followers_ids.filter(
        (id) => id.toString() !== user_id.toString()
      );
      user.followers = user.followers - 1;
      this.influencers_list.unshift(user);
      this.peopleYouFollowList.splice(i, 1);
    },

    getUsersList() {
      this.getInfluencersList(), this.getPeopleYouFollowList();
    },

    getInfluencersList(item) {
      const successHandler = (res) => {
        if (item == "append") {
          res.data.result.forEach((i) => {
            this.influencers_list.push(i);
          });
          this.influencerNumPages = res.data.num;
        } else {
          this.influencers_list = res.data.result;
          this.influencerNumPages = res.data.num;
          this.influencersLoading = false;
        }
      };
      const errorHandler = (err) => {
        console.log(err);
        this.influencersLoading = false;
      };
      const user_id = localStorage.getItem("user_id");
      Axios.request_GET(
        `api/influencers-list/${user_id}/${this.influencerPage}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },

    getPeopleYouFollowList() {
      const successHandler = (res) => {
        console.log(res.data.result);
        this.peopleYouFollowList = res.data.result;
        this.peopleYouFollowListLoading = false;
      };
      const errorHandler = (err) => {
        console.log(err);
        this.peopleYouFollowListLoading = false;
      };
      const user_id = localStorage.getItem("user_id");
      Axios.request_GET(
        `api/people-you-follow-list/${user_id}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },

    goToProfile(id) {
      this.$router.push({ name: "OthersProfilePage", params: { id: id } });
    },

    onInfluencerIntersect(entries, observer) {
      console.log(entries, observer);
      this.influencerHide = false;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.influencerPage += 1;
          if (this.influencerPage <= this.influencerNumPages) {
            this.getInfluencersList("append");
          } else {
            this.influencerHide = true;
          }
        }
      });
    },
  },

  components: {
    ProfileCardComponent,
    TradeForm,
    ReviewandPostTrade,
  },

  mounted() {
    this.getInfluencersList();
    this.influencersLoading = true;
    this.peopleYouFollowListLoading = true;
    if (isAuthenticated()) {
      this.$store.state.Auth.isPrivate = true;
      this.$store.state.Auth.checkStatus = "HOME";
    }
    this.getPeopleYouFollowList();
  },
};
</script>

<style scoped lang="scss">
.main__div {
  background: #f2f8ff !important;
  padding: 20px;
  min-height: 100vh;
}
.follow__title {
  font-weight: bolder;
  font-size: 19px;
  color: #333333;
}
.influencer__follow__title {
  color: #333333;

  font-weight: bolder;
  font-size: 19px;
  margin-top: 10px;
}
.cards-container {
  grid-row-gap: 20px;
  width: 100% !important;
  display: grid;
  grid-template-columns: repeat(1, 100%);
  justify-content: space-between;
}

.influencer-cards-container {
  width: 100% !important;
  display: grid;
  grid-template-columns: repeat(3, 33.33%);
  justify-content: space-between;
  grid-row-gap: 5px;
  grid-column-gap: 5px;
}
.influencer-card-component {
  width: 100%;
}

@media all and (min-width: 1000px) {
  .main__div {
    padding: 28px;
    margin: 0px !important;
    min-height: calc(100vh - 64px);
  }

  .influencer-card-component {
    width: 20%;
    margin-right: 20px;
  }
  .follow__title {
    font-weight: bolder;
    font-size: 19px;
    margin: 0px;
    padding: 0px 0px 10px 0px !important;
  }
  .influencer-cards-container {
    width: 100% !important;
    display: grid;
    grid-template-columns: repeat(5, 18%);
    justify-content: space-between;
    grid-row-gap: 28px;
  }
  .influencer-card-component {
    margin: 0px !important;
    width: 100% !important;
  }
  .cards-container {
    width: 100% !important;
    display: grid;
    grid-template-columns: repeat(3, 31.4%);
    justify-content: space-between;
    grid-row-gap: 28px;
  }
  .card-component {
    margin: 0px !important;
  }

  .follow__title {
    padding: 0px;
  }
}
</style>
